<div class="page-tickets-buy">
    <div class="list-container">
        <div *ngFor="let ticket of compra.entradas; let i = index">
            <mat-divider></mat-divider>
            <div class="align-items-center info-ticket">
                <div class="d-flex info-container" [class.ticket-refund]="ticket.refund">

                    <div class="div-img pointer-in">
                        <!-- <img fallimg class="img-event" src="{{urlEvents+'/'+opt.entradas[0]?.entrada.evento.imageurl}}" /> -->
                        <img (error)="imageUrl = '../../../../assets/img/image_default.png'" class="img-event"
                            [src]="urlEvents+ticket.event_image" />
                    </div>
                    <div class="d-grid align-items-center div-info">
                        <div class="d-flex align-items-center date-event">
                            <i class="fa-light fa-calendar"></i>
                            <span>{{ (ticket.date | date: 'dd MMM':'+0000') }}</span>
                            <span> | </span>
                            <span>{{ (ticket.date | date: 'HH:mm':'+0000') }}h</span>
                        </div>
                        <p class="m-0 name-event">{{ ticket.event }} <span *ngIf="ticket.refund"
                                class="text-refund">Devuelto</span></p>
                        <div class="d-flex info-position-ticket">
                            <p class="m-0 price-ticket" *ngIf="!ticket.isSeasonPass">{{ ticket.priceTotal | number:'2.2-2' }}€</p>
                            <p class="m-0 price-ticket" *ngIf="ticket.isSeasonPass">Incluido en el abono</p>
                            <mat-divider [vertical]="true"></mat-divider>
                            <p class="m-0 name-ticket">{{ ticket.ticket_name }}</p>
                        </div>
                        <div class="d-flex info-position-ticket">
                            <!-- Position -->
                            <p class="m-0 name-ticket" *ngIf="ticket.sectionName">{{ ticket.sectionName }}</p>
                            <mat-divider [vertical]="true" *ngIf="ticket.row && ticket.show_row"></mat-divider>
                            <p class="m-0 name-ticket" *ngIf="ticket.row && ticket.show_row">Fila: {{ ticket.row }}</p>
                            <mat-divider [vertical]="true" *ngIf="ticket.seat && ticket.show_seat_label"></mat-divider>
                            <p class="m-0 name-ticket" *ngIf="ticket.seat"><ng-container *ngIf="ticket.show_seat_label">Butaca: </ng-container>{{ ticket.seat }}</p>

                        </div>
                        <!-- Entrada nominativa: recordar a nombre de quién está y que
                             en el acceso pedirán el documento de identidad -->
                        <!-- Entrada de abonado: el QR de la puerta es el del propio
                             abono, no hay entrada que descargar. -->
                        <div class="nominative-ticket" *ngIf="ticket.isSeasonPass">
                            <i class="fa-light fa-id-card icon-primary"></i>
                            <p class="m-0">
                                Incluida en tu <strong>abono de temporada</strong><span *ngIf="ticket.seasonPassNumber"> (nº {{ ticket.seasonPassNumber }})</span>.
                                En el acceso se lee el QR de tu abono.
                            </p>
                        </div>
                        <div class="nominative-ticket" *ngIf="ticket.nominative">
                            <i class="fa-light fa-id-card icon-primary"></i>
                            <p class="m-0">
                                Entrada nominativa a nombre de <strong>{{ ticket.holderName }}</strong>. En el acceso te
                                pedirán su documento de identidad.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="d-flex btn-container" *ngIf="!ticket.refund">

                    <div class="container-btns" *ngIf="!ticket.isSeasonPass">
                        <div class="content-qr" (click)="printTicket( compra.idOdoo)">
                            <i class="fa-light fa-file-arrow-down"></i>
                            <p class="show-ticket m-0">Descargar entrada</p>
                        </div>
                    </div>
                    <!-- Sin localizador no hay QR que enseñar (p. ej. una reserva de
                         abonado cuyo abono ya está de baja). -->
                    <div class="container-btns" *ngIf="ticket.localizador">
                        <div class="content-qr" (click)="openQr(ticket)">
                            <i class="fa-light fa-qrcode"></i>
                            <p class="show-ticket m-0">Ver entrada</p>
                        </div>
                    </div>
                </div>
                <div class="d-flex btn-container" *ngIf="ticket.refund">

                    <div class="container-btns " *ngIf="!ticket.isSeasonPass">
                        <div class="content-qr disabled">
                            <i class="fa-light fa-file-arrow-down disabled"></i>
                            <p class="show-ticket m-0 disabled">Descargar entrada</p>
                        </div>
                    </div>
                    <div class="container-btns">
                        <div class="content-qr disabled">
                            <i class="fa-light fa-qrcode disabled"></i>
                            <p class="show-ticket m-0 disabled">Ver entrada</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>